import { render } from "./FeedbackForm.vue?vue&type=template&id=53273cfd&scoped=true&ts=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"

import "./FeedbackForm.vue?vue&type=style&index=0&id=53273cfd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53273cfd"]])

export default __exports__